export const WIDGETS_WRAPPER_CLASS = 'widgets-wrapper'
